/**
 * OIDC-based user type matching partnernet's WhUser claims structure.
 * Used internally by AuthService for OIDC claims mapping.
 */
export type WhbabtecUser = {
  // Standard OIDC Claims
  iss: string;
  sub: string;
  aud: string;
  exp: number;
  iat: number;
  nbf: number;
  name: string;
  given_name: string;
  family_name: string;
  preferred_username: string;
  email?: string;

  // Microsoft / CIAM specific
  tid: string;
  oid: string;
  sid: string;
  ver: string;
  acct: number;
  rh: string;
  nonce: string;
  aio: string;

  // Custom claims
  couAccepted?: string;
  country?: string;
  documentTypePermissions?: string;
  groups?: string;
  language?: string;
  oemPermissions?: string;
  whAreaManager?: string;
  whCompany?: string;
  businessPartnerNumber?: string;
};

/**
 * Maps raw OIDC claims to a WhbabtecUser.
 */
export function mapClaimsToUser(claims: Record<string, unknown>): WhbabtecUser {
  return {
    iss: claims['iss'] as string,
    sub: claims['sub'] as string,
    aud: claims['aud'] as string,
    exp: claims['exp'] as number,
    iat: claims['iat'] as number,
    nbf: claims['nbf'] as number,
    name: claims['name'] as string,
    given_name: claims['given_name'] as string,
    family_name: claims['family_name'] as string,
    preferred_username: claims['preferred_username'] as string,
    email: claims['email'] as string,
    tid: claims['tid'] as string,
    oid: claims['oid'] as string,
    sid: claims['sid'] as string,
    ver: claims['ver'] as string,
    acct: claims['acct'] as number,
    rh: claims['rh'] as string,
    nonce: claims['nonce'] as string,
    aio: claims['aio'] as string,
    couAccepted: claims['couAccepted'] as string | undefined,
    country: claims['country'] as string | undefined,
    documentTypePermissions: claims['documentTypePermissions'] as string | undefined,
    groups: claims['groups'] as string | undefined,
    language: claims['language'] as string | undefined,
    oemPermissions: claims['oemPermissions'] as string | undefined,
    whAreaManager: claims['whAreaManager'] as string | undefined,
    whCompany: claims['whCompany'] as string | undefined,
    businessPartnerNumber: claims['businessPartnerNumber'] as string | undefined,
  };
}

export enum WHBABTEC_STORAGE {
  LANGUAGE = 'whbabtec_lang',
}
